/* Outdoor Paws — Reviews slider (stepping carousel)
 * Slow auto-slide (one card at a time) when idle; pauses on hover, arrow/dot use,
 * and while a review block is being edited in the theme customizer. */
(function () {
  'use strict';

  class OpReviews extends HTMLElement {
    connectedCallback() { this.init(); }
    disconnectedCallback() { this._stop(); }

    init() {
      this.viewport = this.querySelector('.opr__viewport');
      this.track = this.querySelector('.opr__track');
      this.prev = this.querySelector('.opr__arrow--prev');
      this.next = this.querySelector('.opr__arrow--next');
      this.dotsWrap = this.querySelector('.opr__dots');
      if (!this.viewport || !this.track) return;

      this.cards = Array.prototype.slice.call(this.track.querySelectorAll('.opr__card'));
      this.interval = (parseInt(this.getAttribute('data-autoplay'), 10) || 0) * 1000;
      this._paused = false;

      this._buildDots();
      this._bind();
      this._syncControls();
      this._maybeStart();
    }

    _step() {
      if (this.cards.length < 2) return this.viewport.clientWidth;
      return Math.round(this.cards[1].getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left);
    }
    _perView() { return Math.max(1, Math.round(this.viewport.clientWidth / this._step())); }
    _index() { return Math.round(this.viewport.scrollLeft / this._step()); }
    _maxIndex() { return Math.max(0, this.cards.length - this._perView()); }

    /* Custom eased scroll so the auto-slide feels slow and smooth */
    _animateTo(left, dur) {
      if (this._raf) cancelAnimationFrame(this._raf);
      var vp = this.viewport, start = vp.scrollLeft, delta = left - start, t0 = null;
      if (Math.abs(delta) < 1) return;
      vp.style.scrollSnapType = 'none';
      var ease = function (p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; };
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        vp.scrollLeft = start + delta * ease(p);
        if (p < 1) { this._raf = requestAnimationFrame(step); }
        else { vp.style.scrollSnapType = ''; this._syncControls(); }
      }.bind(this);
      this._raf = requestAnimationFrame(step);
    }

    _goTo(i, dur) {
      var max = this._maxIndex();
      if (i > max) i = 0;          // loop back to the start
      if (i < 0) i = max;
      this._animateTo(i * this._step(), dur || 650);
    }

    _buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      var pages = this._maxIndex() + 1;
      this.dots = [];
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'opr__dot';
        d.setAttribute('aria-label', 'Go to review ' + (i + 1));
        d.addEventListener('click', function (idx) { this._goTo(idx); this._restart(); }.bind(this, i));
        this.dotsWrap.appendChild(d);
        this.dots.push(d);
      }
    }

    _syncControls() {
      var i = this._index();
      if (this.dots) this.dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }

    _bind() {
      if (this.next) this.next.addEventListener('click', function () { this._goTo(this._index() + 1); this._restart(); }.bind(this));
      if (this.prev) this.prev.addEventListener('click', function () { this._goTo(this._index() - 1); this._restart(); }.bind(this));

      var t;
      this.viewport.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(this._syncControls.bind(this), 90);
      }.bind(this), { passive: true });

      // Pause while the visitor is interacting/reading
      ['mouseenter', 'touchstart', 'pointerdown'].forEach(function (ev) {
        this.addEventListener(ev, this._stop.bind(this), { passive: true });
      }, this);
      ['mouseleave', 'touchend'].forEach(function (ev) {
        this.addEventListener(ev, this._restart.bind(this), { passive: true });
      }, this);

      window.addEventListener('resize', function () {
        clearTimeout(this._rt);
        this._rt = setTimeout(function () { this._buildDots(); this._syncControls(); }.bind(this), 200);
      }.bind(this));

      // In the theme editor: keep auto-sliding, but pause while a review is selected for editing
      document.addEventListener('shopify:block:select', function (e) {
        if (this.contains(e.target)) this._pauseHard();
      }.bind(this));
      document.addEventListener('shopify:block:deselect', function (e) {
        if (this.contains(e.target)) { this._paused = false; this._restart(); }
      }.bind(this));
    }

    _start() {
      this._stop();
      if (this.interval <= 0 || this._paused || this.cards.length < 2) return;
      this._timer = setInterval(function () { this._goTo(this._index() + 1, 900); }, this.interval);
    }
    _stop() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
    _maybeStart() { this._start(); }
    _restart() { if (!this._paused) this._start(); }
    _pauseHard() { this._paused = true; this._stop(); }
  }

  if (!window.customElements.get('op-reviews')) {
    window.customElements.define('op-reviews', OpReviews);
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('op-reviews'); if (el && el.init) el.init();
  });
})();
